import type { TFunction } from "i18next";
import * as z from "zod";

export const roleFormSchema = (t: TFunction) => {
  return z.object({
    name: z
      .string()
      .nonempty(t("field_required"))
      .min(2, t("role_name_min_length")),
    description: z.string().optional(),
    permissionIds: z.array(z.string()).min(1, t("permissions_required")),
    updatedAt: z.string().optional(),
  });
};

export type RoleFormSchemaValues = z.infer<ReturnType<typeof roleFormSchema>>;
